import React, { useEffect, useMemo } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector } from "react-redux";
import { createCheckoutSessionThunk } from "../store/stripe";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./StripeCheckoutForm.js";

const PUBLISHABLE_KEY = "pk_live_51N1jsSIzDtG53Sp0IYroac8Yq8aSbX7PQgISERDGaQNviBMnz4SGJ4RhjZws64QrELl0aJoWqtyYe5W3Ud6bqhmV00sR5crhK1";

function hasValidContact(name, phone) {
    const trimmedName = String(name || '').trim();
    const digits = String(phone || '').replace(/\D/g, '');
    return Boolean(trimmedName) && digits.length === 10;
}

const CheckoutApp = ({
    tip,
    customTip,
    restaurantId,
    name,
    phone,
    cartItems,
    coupon,
    address,
    selectedTime,
    freeItem,
    rewardItem,
    discountReward,
    email,
    account_id,
    aptNumber,
    deliveryInstructions,
    distanceText,
    specialItem,
}) => {
    const stripePromise = useMemo(
        () => loadStripe(PUBLISHABLE_KEY, {
            // stripeAccount: account_id
        }),
        [account_id]
    );

    const dispatch = useDispatch();
    const clientSecret = useSelector((state) => state?.stripe?.data?.clientSecret);
    const contactOk = hasValidContact(name, phone);
    const safeName = String(name || '').trim();
    const safePhone = String(phone || '').replace(/\D/g, '');

    useEffect(() => {
        if (!contactOk) return;

        dispatch(createCheckoutSessionThunk(
            tip,
            customTip,
            restaurantId,
            cartItems,
            coupon,
            address,
            safeName,
            safePhone,
            selectedTime,
            freeItem,
            rewardItem,
            discountReward,
            email,
            aptNumber,
            deliveryInstructions,
            null,
            distanceText,
            specialItem
        ));
    }, [
        dispatch,
        contactOk,
        tip,
        customTip,
        restaurantId,
        cartItems,
        coupon,
        address,
        safeName,
        safePhone,
        selectedTime,
        freeItem,
        rewardItem,
        discountReward,
        email,
        aptNumber,
        deliveryInstructions,
        distanceText,
        specialItem,
    ]);

    if (!contactOk) {
        return (
            <p className="text-danger mt-3 mb-0">
                Please enter your name and a valid 10-digit phone number before paying.
            </p>
        );
    }

    const appearance = {
        theme: 'flat',
    };
    const options = {
        clientSecret,
        appearance,
        loader: 'auto',
    };

    return (
        <div className="checkout-stripe-wrap">
            {clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm />
                </Elements>
            )}
        </div>
    );
}

export default CheckoutApp;
